<div class="setting-item">
  <small class="debug">{{ me }}</small>
  <div class="setting-header-vertical">
    <div class="setting-title-row">
      <mat-icon class="setting-icon">{{ icon }}</mat-icon>
      <span class="setting-title">{{ title }}</span>
    </div>
    <section>
      <mat-button-toggle-group
        [name]="name"
        [attr.aria-label]="ariaLabel"
        [hideSingleSelectionIndicator]="hideSingleSelectionIndicator"
        [(ngModel)]="value"
        (change)="onToggleChange($event)">
        @for (option of options; track option) {
          <mat-button-toggle
            [value]="option.value">
            {{ option.label }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </section>
  </div>
</div>
